import React, { useEffect } from 'react'
import { TableCPOLD2 } from 'common/old-refactory/table/TableCPOLD2'
import { CardDashboardWidgetWrapperCP } from 'main/modules/dashboard/components/card-dashboard-widget-wrapper/CardDashboardWidgetWrapperCP'
import { useRequest } from 'main/common/request-manager/use-request/UseRequest'
import { IGenericListResponseDTO } from 'main/common/dtos/responses/IGenericListResponseDTO'
import { RequestUtils } from 'main/common/request-manager/RequestUtils'
import { DashboardRequests } from 'main/modules/dashboard/services/DashboardRequests'
import { OppsByFranchiseOrderingEnum } from 'main/modules/dashboard/services/enums/OppsByFranchiseOrderingEnum'
import { FollowupsByFranchiseTableUtils } from 'main/modules/dashboard/components/widget-table-followups-by-franchise/inner/FollowupsByFranchiseTableUtils'
import { IFollowUpsByFranchiseListItemResponseDTO } from 'main/modules/dashboard/services/dtos/response/IFollowUpsByFranchiseListItemResponseDTO'

interface ICPProps {
    franchiseCodes?: number[]
}

/**
 * Componente de tabela que followups.
 */
export function WidgetTableFollowupsByFranchiseCP(props: ICPProps): JSX.Element {

    const getFollowupsByFranchiseRequest = useRequest<IGenericListResponseDTO<IFollowUpsByFranchiseListItemResponseDTO>>()
    useEffect(onGetFollowupsByFranchiseRequestChange, [getFollowupsByFranchiseRequest.isAwaiting])

    useEffect(init, [props.franchiseCodes])

    /**
     * Busca dados na api.
     */
    function init(): void {
        getFollowupsByFranchiseRequest.runRequest(DashboardRequests.getFollowupsByFranchise({
            franchiseCodes: props.franchiseCodes,
            orderingCriteria: OppsByFranchiseOrderingEnum.PLANNEDS_TODAY,
            orderingAscending: false,
        }))
    }

    /**
     * Retorno da requisicao.
     */
    function onGetFollowupsByFranchiseRequestChange(): void {
        if (!RequestUtils.isValidRequestReturn(getFollowupsByFranchiseRequest, 'Não foi possível obter sumário de followups por unidade'))
            return
    }

    return (
        <CardDashboardWidgetWrapperCP
            title={'Followups por unidade'}
            className={'card-dashboard-widget'}
            flex={'1'}
        >
            <TableCPOLD2
                columns={FollowupsByFranchiseTableUtils.getTableColumns()}
                data={getFollowupsByFranchiseRequest.responseData?.list}
                loading={getFollowupsByFranchiseRequest.isAwaiting}
            />
        </CardDashboardWidgetWrapperCP>
    )
}
